import React from "react";
import { ESortOrder } from "@domains/utils/sort";
const SortLabels = ({ LabelText, closeBtn, order }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ed-sort-label-wrapper" }, closeBtn ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sort-tag-container" },
                React.createElement("div", { className: "ed-sort-label-text" },
                    LabelText,
                    order && order == (ESortOrder === null || ESortOrder === void 0 ? void 0 : ESortOrder.ASC) ? (React.createElement("span", null,
                        React.createElement("i", { className: "edel-icon-point-arrow-up sortOrder" }))) : (React.createElement("span", null,
                        React.createElement("i", { className: "edel-icon-point-arrow-down sortOrder" }))),
                    React.createElement("span", { className: "edel-icon-sort" }))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "tag-container" },
                React.createElement("div", { className: "ed-sort-label-text" }, LabelText)))))));
};
export default SortLabels;
